<template>
  <a class="video" :href="`https://www.youtube.com/watch?v=${id}`" target="_blank" rel="noopener">
    <span class="thumb">
      <img :src="`https://i.ytimg.com/vi/${id}/hqdefault.jpg`" :alt="t('Miniature de l\'interview', 'Interview thumbnail')" loading="lazy" />
      <span class="play" aria-hidden="true">▶</span>
    </span>
    <span>
      <span class="k">Interview · Horizon IA</span>
      <h3>{{ t("Ce mouvement tech en Afrique est en train de tout changer", "This tech movement in Africa is changing everything") }}</h3>
      <p class="desc">
        {{ t("J'y parle de Dev Girls et de la place des femmes dans la tech en Afrique.", "I talk about Dev Girls and the place of women in tech in Africa (in French).") }}
      </p>
    </span>
  </a>
</template>

<script>
import { YT_ID } from "@/content";
import { useI18n } from "@/i18n";

export default {
  name: "VideoCard",
  setup: () => ({ ...useI18n(), id: YT_ID }),
};
</script>

<style scoped>
.desc {
  font-size: 15px;
}
</style>
